import React from 'react';
import HomeContainer from '../HomeContainer';

const Registration4 = () => {
  return (
    <HomeContainer>
    <div>
      <h5>Advanced Computer Vision</h5>
      <p>Coming soon...</p>
      {/* Form can be added here */}
    </div>
    </HomeContainer>
  );
};

export default Registration4;
